// 탈퇴 토스트, 이메일 중복 에러 UI 분기
export const ANDROID_APP_VERSION = '1.0.12'
// 회원탈퇴 시 앱에서 재인증 요청 분기 버전
export const REAUTH_FOR_APP_UNREGISTER_VERSION = {
  ANDROID: '1.0.16',
  IOS: '1.0.9',
}
// 루케플 앱 버전
export const PLUS_APP_VERSION = '1.1.0'
